import React, { FunctionComponent, useMemo, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import useClickOutside from 'Frontend/hooks/useClickOutside'
import { useTranslation } from 'react-i18next'
import { IWorkroomMember } from 'Frontend/scripts/models/workrooms.model'
import { changeWorkroomOwner } from 'Frontend/scripts/services/workrooms.service'

interface UnassignedThreadProps {
  workroomId: number
  isVisible: boolean
  members: IWorkroomMember[]
  callback: (isOpen: boolean) => void
}

const AssignOwner: FunctionComponent<UnassignedThreadProps> = ({ workroomId, isVisible, members, callback }) => {
  const { t } = useTranslation()
  const [filter, setFilter] = useState<string>('')
  const ref = useClickOutside(() => {
    callback(false)
    setFilter('')
  })

  const makeWorkroomAdmin = (userId: number) => {
    changeWorkroomOwner(workroomId, userId).then(() => {
      callback(false)
    })
  }

  const filteredUsers = useMemo(() => {
    if (!filter) return members

    const filtered = members.filter((member) => {
      return (
        member.firstname.toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
        member.lastname.toLowerCase().indexOf(filter.toLowerCase()) > -1
      )
    })

    return filtered
  }, [members, filter])

  const hasFilteredUsers = filteredUsers?.length > 0

  return (
    <>
      {isVisible && (
        <div className="manage-forums__user-select-container" ref={ref}>
          <h3 className="h4">{t('dashboard.workrooms.choose-owner')}</h3>
          <Form.Group>
            <Form.Label htmlFor="user-filter">{t('filter-users')}</Form.Label>
            <Form.Control
              id="user-filter"
              type="text"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilter(e.target.value)}
            />
          </Form.Group>
          {hasFilteredUsers ? (
            <ul className="list-unstyled">
              {filteredUsers?.map((user) => (
                <li className="manage-forums__user-list-item" key={`user-${user.userId}`}>
                  <Button className="manage-forums__user gap-2" onClick={() => makeWorkroomAdmin(user.userId)}>
                    {user.profileImageUrl != null ? (
                      <img
                        className="manage-forums__user-profile-image"
                        src={user.profileImageUrl}
                        alt={`${t('image-of')} ${user?.firstname} ${user?.lastname}`}
                      />
                    ) : (
                      <div className="manage-forums__user-initial-letters">
                        {user?.firstname?.charAt(0)}
                        {user?.lastname?.charAt(0)}
                      </div>
                    )}
                    {user.firstname}&nbsp;
                    {user.lastname}
                  </Button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="my-2 fs-5 text">{t('no-user-found')}</p>
          )}
        </div>
      )}
    </>
  )
}

export default AssignOwner
